// extracted by mini-css-extract-plugin
export var guideWrapper = "guide-module--guideWrapper--10462";
export var guide_section = "guide-module--guide_section--63de0";
export var innerTabContent = "guide-module--innerTabContent--a546e";
export var leftTabbox = "guide-module--leftTabbox--d8506";
export var listTab = "guide-module--listTab--ffa81";
export var rightTabContent = "guide-module--rightTabContent--240bd";
export var tabBox = "guide-module--tabBox--cb0c4";
export var ulList = "guide-module--ulList--611d8";